module.exports = __webpack_public_path__ + "static/4-c36e88d20a6491c3a23f978424b76f00.jpg";